import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface FormActionsProps {
  isSubmitting: boolean;
  onSaveAsDraft: (e: React.MouseEvent) => void;
  isEditMode?: boolean;
  isDraftProject?: boolean;
}

const FormActions: React.FC<FormActionsProps> = ({ 
  isSubmitting, 
  onSaveAsDraft, 
  isEditMode = false,
  isDraftProject = false
}) => {
  const navigate = useNavigate();

  const showDraftButton = !isEditMode || isDraftProject;

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 4 }}>
        <Button type="button" variant="outlined" onClick={() => navigate('/')}>
          Cancel
        </Button>
        
        {showDraftButton && (
          <Button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSaveAsDraft(e);
            }}
            disabled={isSubmitting}
            variant="outlined"
            color="secondary"
            id="draft-button"
          >
            {isDraftProject ? 'Save Draft' : 'Save as Draft'}
          </Button>
        )}
        
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isSubmitting}
          id="submit-button"
          sx={{ display: 'block' }}
        >
          {isSubmitting 
            ? 'Submitting...' 
            : isDraftProject 
              ? 'Submit' 
              : isEditMode 
                ? 'Update Project' 
                : 'Submit Project'
          }
        </Button>
      </Box>
    </Box>
  );
};

export default FormActions;
